module.exports = __webpack_public_path__ + "img/dubai.9b41d5ed.jpg";